<template>
    <div class="box1">
        <div class="handle-box-search order">
            <el-row type="flex" justify="start" style="margin-bottom: 20px">
                <div class="order-export-title" style="display: flex">
                    <div class="orHead">订单导出</div>
                    <span class="remark"
                        >仅支持导出最近三个月内的订单，超出三个月的请使用<el-button type="text" @click="orderHis">历史订单导出</el-button
                        >功能</span
                    >
                </div>
            </el-row>

            <commonExport ref="commonExport" @changeType="changeType" @changeTime="changeTime">
                <template slot="order_type">
                    <span class="title">订单类型:</span>
                    <el-select
                        v-model="submit_data.type"
                        placeholder="请选择模式"
                        style="width: 350px; margin-right: 20px"
                        @change="typeChange"
                        clearable
                    >
                        <!-- <el-option label="当前订单" value="0"></el-option>
                            <el-option label="历史订单" value="1"></el-option>
                            <el-option label="全部当前订单" value="2"></el-option>
                            <el-option label="全部历史订单" value="3"></el-option>
                            <el-option label="销单订单" value="4"></el-option>
                            <el-option label="历史销单订单" value="5"></el-option> -->
                        <el-option label="全部订单" value="2"></el-option>
                        <el-option label="已支付订单" value="0"></el-option>
                        <el-option label="销单订单" value="4"></el-option>
                        <el-option label="三方无效销单" value="6"></el-option>
                    </el-select>
                </template>
                <template slot="his_type">
                    <span class="title">查询时间:</span>
                    <el-date-picker
                        v-model="search_time"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-value="default_value"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange"
                        style="width: 350px"
                        :picker-options="pickerOptions1"
                    >
                    </el-date-picker>
                    <!-- 比如今天是2月9日，那么当前月2月算一个月，所以三个月以内的订单就是从12月1日到当前天的数据 -->
                    <span class="remark">仅支持查询最近三个月内的订单</span>
                </template>
            </commonExport>
        </div>
    </div>
</template>

<script>
import commonExport from './commonExport.vue';

var _this;
export default {
    components: {
        commonExport
    },

    data() {
        return {
            search_time: '',
            default_value: '',

            pickerOptions1: {
                disabledDate(time) {
                    var thatDay = time.getTime();
                    console.log('--------');

                    // _this.default_value = new Date(threeMonths)

                    // 点击时间控件打开的图形中显示的每一天 > 当前日期  || 图形中显示的每一天 < 三个月之前的日期
                    return thatDay > Date.now() || thatDay < _this.computingTime();
                }
            },
            submit_data: {
                fixed_array: '',
                type: ''
            }
        };
    },
    created() {
        _this = this;

        //设置查询时间的默认时间，比如现在是2023年2月，三个月内的数据可查询，则时间控件打开的时候，显示可选时间范围为2022年12月1日以后的可选
        _this.default_value = new Date(_this.computingTime());
    },

    methods: {
        changeTime() {
            _this.search_time = '';
        },
        changeType() {
            _this.submit_data.type = '';
        },
        computingTime() {
            let month = new Date().getMonth(); //返回当前月份，如，当前是2月，则month值为1     （0-11 代表1-12月 ）
            let twoMonthOld = month - 2; // 当前月份-2    两个月前的月份，1-2=-1（2022年12月）

            if (twoMonthOld < 0) {
                //两个月之前的月份 比如当前是2月，2个月之前就是当前月份减2，也就是1-2=-1，当前月不管几号都算一个月，所以3个月要用当前月减2（0-11 代表1-12月 ）

                twoMonthOld += 12; //-1+12=11
            }

            // console.log(twoMonthOld);

            let year = new Date().getFullYear(); //返回当前年份

            let twoMonthOldStr; //去年的数据

            if (twoMonthOld > month) {
                // 2个月前的月份大于现在的月份(去年)，

                twoMonthOldStr = `${year - 1}/${twoMonthOld + 1}/1`; //拼接字符串

                // console.log(new Date(twoMonthOldStr).getTime());
            } else {
                // 2个月前的月份不大于现在的月份(今年) 如，当前月,2023年2月，2-2=0，
                twoMonthOldStr = `${year}/${twoMonthOld + 1}/1`;
            }

            let threeMonths = new Date(twoMonthOldStr).getTime();

            return threeMonths;
        },
        timeChange(val) {
            if (val != null) {
                _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.submit_data.fixed_array = '';
            }
            // 获取子组件的dom节点，直接改变子组件submit_data中fixed_array的值
            this.$refs.commonExport.$data.submit_data.fixed_array = this.submit_data.fixed_array;
            //  console.log(this.$refs.commonExport.$data.submit_data);
        },
        orderHis() {
            // console.log(this.$route.path);

            this.$router.push('/historyOrderExport');
        },
        typeChange() {
            let type = '';
            // 获取子组件的dom节点，直接改变子组件submit_data中type的值
            switch (this.submit_data.type) {
                case '0':
                    type = '已支付订单';
                    break;
                case '2':
                    type = '全部订单';
                    break;
                case '4':
                    type = '销单订单';
                    break;
                case '6':
                    type = '三方无效销单';
            }
             // 获取子组件的dom节点，直接改变子组件submit_data中type的值 给导出的excel文件添加订单类型字段
             this.$refs.commonExport.$data.type = type;
            this.$refs.commonExport.$data.submit_data.type = _this.submit_data.type;
     
           
         
        
        }
    }
};
</script>

<style scoped>
.box1 {
    height: 100% !important;
}

.handle-box-search.order .title {
    font-size: 14px;
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 5px;
    color: #747474;
}
.order-export-title {
    display: flex;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #f5f7fa;
}
.remark {
    font-size: 14px;
    margin-left: 10px;
    color: #c2c4c9;
}
.handle-box-search.order {
    background-color: #fff !important;
}
</style>

<style>
.order-export-checkbox .el-checkbox__input {
    display: none !important;
}
</style>
